/**
 * `[CompetitiveElo] seasonId=12 name="September 2026" Ranked Standard 1520 -> 1541 (+21) modes=[...] default=1500`
 * Appended by the modified client after the battle log once the season-rank response arrives.
 */
export type CompetitiveElo = {
  seasonId: string;
  seasonName?: string;
  /** Free text between the season and the numbers, e.g. "Ranked Standard" (gameplayType + gameMode). */
  mode?: string;
  previousElo: number;
  newElo: number;
  delta: number;
  modes?: string[];
  defaultElo?: number;
  raw: string;
};

const LINE =
  /^\[CompetitiveElo\]\s+seasonId=(\S+)(?:\s+name="([^"]*)")?\s*(.*?)\s*(\d+)\s*->\s*(\d+)\s*\(([+-]?\d+)\)(?:\s+modes=\[([^\]]*)\])?(?:\s+default=(\d+))?\s*$/;

export function parseCompetitiveElo(line: string): CompetitiveElo | undefined {
  const m = LINE.exec(line.trim());
  if (m === null) return undefined;
  const result: CompetitiveElo = {
    seasonId: m[1] ?? "",
    previousElo: Number.parseInt(m[4] ?? "0", 10),
    newElo: Number.parseInt(m[5] ?? "0", 10),
    delta: Number.parseInt(m[6] ?? "0", 10),
    raw: line.trim(),
  };
  const name = m[2];
  if (name !== undefined && name.length > 0) result.seasonName = name;
  const mode = (m[3] ?? "").trim();
  if (mode.length > 0) result.mode = mode;
  const modes = m[7];
  if (modes !== undefined) {
    const list = modes
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0 && s !== "none");
    if (list.length > 0) result.modes = list;
  }
  if (m[8] !== undefined) result.defaultElo = Number.parseInt(m[8], 10);
  return result;
}

/** Pull `[CompetitiveElo]` (and any other `[Tag]` trailer lines) out of a tagged-line list. */
export function findCompetitiveElo(lines: readonly string[]): CompetitiveElo | undefined {
  for (let i = lines.length - 1; i >= 0; i -= 1) {
    const parsed = parseCompetitiveElo(lines[i] ?? "");
    if (parsed !== undefined) return parsed;
  }
  return undefined;
}
